import type { DriveFolder } from '@/api/services/drive.service'

export function childFolders(folders: DriveFolder[], parentId: string | null): DriveFolder[] {
  return folders.filter((folder) => folder.parentId === parentId)
}

/** The folder and its parents, top level first. Empty when the folder isn't in the list. */
export function folderPath(folders: DriveFolder[], id: string | null): DriveFolder[] {
  const byId = new Map(folders.map((folder) => [folder.id, folder]))
  const path: DriveFolder[] = []
  let current = id ? byId.get(id) : undefined
  while (current) {
    path.unshift(current)
    current = current.parentId ? byId.get(current.parentId) : undefined
  }
  return path
}

/** Every folder in tree order, with how deep it sits. */
export function flattenFolders(
  folders: DriveFolder[],
  parentId: string | null = null,
  depth = 0,
): Array<{ folder: DriveFolder; depth: number }> {
  return childFolders(folders, parentId).flatMap((folder) => [
    { folder, depth },
    ...flattenFolders(folders, folder.id, depth + 1),
  ])
}

export function countLabel(count: number, noun: string): string {
  return `${count.toLocaleString()} ${noun}${count === 1 ? '' : 's'}`
}

/** What a folder row holds, e.g. "12 files · 3 folders". */
export function folderSummary(folders: DriveFolder[], folder: DriveFolder): string {
  const subfolders = childFolders(folders, folder.id).length
  const parts = [countLabel(folder.fileCount, 'file')]
  if (subfolders > 0) parts.push(countLabel(subfolders, 'folder'))
  return parts.join(' · ')
}
